<template>
  <button
    class="base-btn base-btn--outline-blue"
    @click="onClick"
  >
    <BasePreloader v-if="loading" />
    <BaseSvg name="ico-plus" width="1.3rem" height="1.3rem"/>
    <span class="base-btn__text">{{ $tResumePage('confirm_resume') }}</span>
  </button>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: 'ConfirmResumeBtn',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    receivedResumeId() {
      return Number(this.$route.params.resumeId);
    },
  },
  methods: {
    ...mapActions('vacancies/responses', [
      'confirmCandidateResume',
    ]),

    onClick() {
      this.$vModal.open('confirm', {
        title: this.$tResumePage('confirm_resume') + '?',
        successBtnClass: 'base-btn--outline-blue',
        onAccept: this.onConfirm,
      });
    },
    onConfirm() {
      if (this.loading) return;

      const err = () => this.$vModal.open('warning', { title: 'Something went wrong' });

      if (!this.receivedResumeId) {
        return err();
      }

      this.loading = true;

      this.confirmCandidateResume({ resume_id: this.receivedResumeId })
        .then(() => this.$emit('confirm'))
        .catch(err)
        .finally(() => this.loading = false);
    },
  },
};
</script>
